module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-number"
  }, [_c('a', {
    attrs: {
      "id": "page-1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/toc#toc-prologue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "cnorn1"
  }, [_c('span', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/Art_ctorn.jpg"
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_vm._v("Roslin Castle, Scotland, August 1379")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("H")]), _vm._v("e couldn’t believe that a mere female a foot shorter than he was had pushed him off the castle’s wall-walk. He must have fallen a hundred feet and had hit the water with such stunning force that a lesser man would have died from the impact. But although he had gone headfirst over the parapet, he pushed himself away from the wall and twisted like a cat, managing to land feetfirst at an angle that put him face up in the water. He let the river Esk’s swift current do the rest.")]), _vm._v(" "), _c('p', [_vm._v("Even so, he soon hit one of the river’s mighty boulders, which stunned him and spun him like a child’s top. By using his great strength to avoid the next one, he managed to keep it from knocking him senseless. Then he was in the swiftest part of the flow, face up and feetfirst again, catapulting along at terrifying speed.")]), _vm._v(" "), _c('p', [_vm._v("To be on his back, unable to see where he was going, gulping what seemed to be as much water as air, and otherwise letting the river control him went right against his "), _c('a', {
    attrs: {
      "id": "page-2"
    }
  }), _vm._v("nature. But knowing that the water would be deepest where it ran swiftest, he forced himself to let it carry him as it would until he could regain his wits.")]), _vm._v(" "), _c('p', [_vm._v("The lass had taken him completely by surprise. But she would pay heavily for that, she and everyone she held dear. Whatever it took, he would survive to reclaim His treasure and seek his own vengeance.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12bbb14d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 75
// module chunks = 0